import { render, staticRenderFns } from "./inte-matching.vue?vue&type=template&id=c86d167c&scoped=true"
import script from "./inte-matching.vue?vue&type=script&lang=js"
export * from "./inte-matching.vue?vue&type=script&lang=js"
import style0 from "./inte-matching.vue?vue&type=style&index=0&id=c86d167c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86d167c",
  null
  
)

export default component.exports